import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';

export const selectUserState = createFeatureSelector<UserState>('user');

// Basic selectors
export const selectUser = createSelector(
	selectUserState,
	(state) => state.user
);

export const selectAuthStatus = createSelector(
	selectUserState,
	(state) => state.authStatus
);

export const selectUserError = createSelector(
	selectUserState,
	(state) => state.error
);
